import { inject } from 'mobx-react';
import { TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { PropertyListingHeaderMessages } from '@shared-ui/lodging-property-listing';

import { SearchResultsStore } from 'stores/search-results-store';

import { UitkTypeSize, UitkTypeWeight } from 'uitk-react-text/dist/types';

import { UitkSpacing } from 'uitk-react-spacing';

import { SortAndFiltersViewType } from 'src/common/__generated__/api';

interface CustomTemplateComponent extends TemplateComponent {
  config?: {
    view?: SortAndFiltersViewType;
    size?: UitkTypeSize;
    weight?: UitkTypeWeight;
  };
}

export interface SplitViewResultsHeaderProps extends TemplateComponentProps {
  searchResults?: SearchResultsStore;
  templateComponent: CustomTemplateComponent;
}

export const SplitViewResultsHeader: React.FC<SplitViewResultsHeaderProps> = inject('searchResults')(
  ({ searchResults, templateComponent }) => {
    // don't render header at all if there are no search results
    if (!searchResults) {
      return null;
    }

    const { isLoading, resultMessages } = searchResults;
    const isError = searchResults?.isError;
    const { config } = templateComponent;

    // at some future point we might render a loading message, but until then, the component should return null while loading
    if (isLoading || isError || !resultMessages || resultMessages.length === 0) {
      return null;
    }

    return (
      <ErrorBoundary label="hotel.search.tools">
        <UitkSpacing margin={{ block: 'three' }}>
          <section data-stid="split-view-results-header">
            <header>
              <PropertyListingHeaderMessages messages={resultMessages} fontSize={config?.size} fontWeight={config?.weight} />
            </header>
          </section>
        </UitkSpacing>
      </ErrorBoundary>
    );
  }
);
